export default __webpack_public_path__ + "static/media/cave-back.551df3a0.png";